import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function (date, nullable = false) {
  if (!date) {
    return nullable ? null : "-";
  }

  date = date.substring(0, 10);

  const [year, month, day] = date.split("-");
  return `${day}/${month}/${year}`;
});

Vue.filter("formatDateTime", function (datetime) {
  if (!datetime) {
    return "-";
  }

  const [date, time] = datetime.split(" ");

  const [year, month, day] = date.split("-");
  return `${day}/${month}/${year} ${time}`;
});

Vue.filter("formatUTCDateTime", function (datetime) {
  if (!datetime) {
    return "-";
  }

  const localDateTime = moment
    .utc(datetime)
    .local()
    .format("YYYY-MM-DD HH:mm:ss");

  return moment(localDateTime).format("DD/MM/YYYY HH:mm:ss");
});
